import { useRoutes } from 'react-router-dom';

// routes
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import NewCampaignRoutes from './NewCampaignRoutes';
import GeneratorRoutes from './GeneratorRoutes';
import PackageRoutes from './PackageRoutes';
import CreativeEditRoutes from './CreativeEditRoutes';
import PageNotFoundRoutes from './PageNotFoundRoutes';
import CreatorRoutes from './CreatorRoutes';

// ==============================|| ROUTING RENDER ||============================== //

// export default function ThemeRoutes() {
//     return [LoginRoutes, MainRoutes, NewCampaignRoutes, GeneratorRoutes, PackageRoutes, CreativeEditRoutes, PageNotFoundRoutes];
// }

const AppRoutes = [{
    path: '/',
    children: [LoginRoutes, MainRoutes, NewCampaignRoutes, GeneratorRoutes, PackageRoutes, CreativeEditRoutes, PageNotFoundRoutes, CreatorRoutes]
}];

export default AppRoutes;
